import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CultureService } from 'src/app/modules/core/services/culture.service';
import { DocumentReader } from 'src/app/modules/core/store/models';

@Component({
    selector: 'app-number-cell',
    templateUrl: './number-cell.component.html',
    styleUrls: ['./number-cell.component.scss'],
    standalone: false
})
export class NumberCellComponent implements OnInit {
  value: any;

  constructor(private translateService: TranslateService, private cultureService: CultureService) {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;
    const field = params.schemaField;
    const reader = new DocumentReader(document);

    this.value = !!params.data ? reader.getFormattedFieldValue(field.systemName, field, this.cultureService)
      : (!!params.value ? reader.formatNumber(params.value, field?.settings?.format, this.cultureService) : null);
  }
}
